import React from "react";
import { Info } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { GLOSSARY } from "@/lib/i18n_glossary";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

// Collision-aware popover so the note always stays inside the viewport on mobile.
export default function YieldMethodologyInfo({ dark = false, className = "" }) {
  const { lang } = useLang();
  const isAR = lang === "ar";
  const text = isAR ? GLOSSARY.yieldMethodologyShort.ar : GLOSSARY.yieldMethodologyShort.en;
  return (
    <span className={`relative inline-flex items-center ${className}`}>
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            onClick={(e) => e.stopPropagation()}
            aria-label={isAR ? "منهجية العائد" : "Yield methodology"}
            data-testid="yield-methodology-info"
            className={`inline-flex items-center justify-center w-3.5 h-3.5 rounded-full opacity-70 hover:opacity-100 focus:opacity-100 outline-none transition-opacity ${
              dark ? "text-propertic-paper/80" : "text-propertic-muted"
            }`}
          >
            <Info className="w-3.5 h-3.5" />
          </button>
        </PopoverTrigger>
        <PopoverContent
          collisionPadding={12}
          dir={isAR ? "rtl" : "ltr"}
          data-testid="yield-methodology-tooltip"
          className="w-[min(280px,calc(100vw-24px))] rounded-2xl text-[12px] leading-relaxed text-propertic-ink"
        >
          {text}
        </PopoverContent>
      </Popover>
    </span>
  );
}
